// eslint-disable-next-line import/no-cycle
import {

    SETTING_CREATE_PACKAGE_CATEGORY,
    SETTING_CREATE_PACKAGE_CATEGORY_SUCCESS,
    SETTING_UPDATE_PACKAGE_CATEGORY,
    SETTING_UPDATE_PACKAGE_CATEGORY_SUCCESS,
    SETTING_LOAD_PACKAGE_CATEGORY,
    SETTING_LOAD_PACKAGE_CATEGORY_SUCCESS,
    SETTING_DELETE_PACKAGE_CATEGORY,
    SETTING_DELETE_PACKAGE_CATEGORY_SUCCESS,

    SETTING_LOAD_PACKAGE,
    SETTING_LOAD_PACKAGE_SUCCESS,
    SETTING_CREATE_PACKAGE,
    SETTING_CREATE_PACKAGE_SUCCESS,
    SETTING_UPDATE_PACKAGE,
    SETTING_UPDATE_PACKAGE_SUCCESS,
    SETTING_DELETE_PACKAGE,
    SETTING_DELETE_PACKAGE_SUCCESS,
    SETTING_UPDATE_PACKAGE_STATUS,
    SETTING_UPDATE_PACKAGE_STATUS_SUCCESS,

} from '../../actions';

// // -------------------- getPackageCategory --------------------- //
export const getPackageCategory = (data, token) => ({
    type: SETTING_LOAD_PACKAGE_CATEGORY,
    payload: data,
    token
});
export const getPackageCategorySuccess = (data, list) => ({
    type: SETTING_LOAD_PACKAGE_CATEGORY_SUCCESS,
    payload: data,
    payloadlist: list
});

// // -------------------- createPackageCategory --------------------- //
export const addPackageCategory = (data, token) => ({
    type: SETTING_CREATE_PACKAGE_CATEGORY,
    payload: data,
    token
});
export const addPackageCategorySuccess = () => ({
    type: SETTING_CREATE_PACKAGE_CATEGORY_SUCCESS,
});

// // -------------------- updatePackageCategory --------------------- //
export const updatePackageCategory = (data, token) => ({
    type: SETTING_UPDATE_PACKAGE_CATEGORY,
    payload: data,
    token
});
export const updatePackageCategorySuccess = () => ({
    type: SETTING_UPDATE_PACKAGE_CATEGORY_SUCCESS,
});

// // -------------------- deletePackageCategory --------------------- //
export const deletePackageCategory = (data, token) => ({
    type: SETTING_DELETE_PACKAGE_CATEGORY,
    payload: data,
    token
});
export const deletePackageCategorySuccess = () => ({
    type: SETTING_DELETE_PACKAGE_CATEGORY_SUCCESS,
});

// // -------------------- getPackage --------------------- //
export const getPackage = (data, token) => ({
    type: SETTING_LOAD_PACKAGE,
    payload: data,
    token
});
export const getPackageSuccess = (data, list) => ({
    type: SETTING_LOAD_PACKAGE_SUCCESS,
    payload: data,
    payloadlist: list
});

// // -------------------- createPackage --------------------- //
export const createPackage = (data, token) => ({
    type: SETTING_CREATE_PACKAGE,
    payload: data,
    token
});
export const createPackageSuccess = () => ({
    type: SETTING_CREATE_PACKAGE_SUCCESS,
});

// // -------------------- updatePackage --------------------- //
export const updatePackage = (data, token) => ({
    type: SETTING_UPDATE_PACKAGE,
    payload: data,
    token
});
export const updatePackageSuccess = () => ({
    type: SETTING_UPDATE_PACKAGE_SUCCESS,
});

// // -------------------- deletePackage --------------------- //
export const deletePackage = (data, token) => ({
    type: SETTING_DELETE_PACKAGE,
    payload: data,
    token
});
export const deletePackageSuccess = () => ({
    type: SETTING_DELETE_PACKAGE_SUCCESS,
});

// // -------------------- updateChangeStatusPackage --------------------- //
export const updateChangeStatusPackage = (data, token) => ({
    type: SETTING_UPDATE_PACKAGE_STATUS,
    payload: data,
    token
});
export const updateChangeStatusPackageSuccess = () => ({
    type: SETTING_UPDATE_PACKAGE_STATUS_SUCCESS,
});
